/* FartMart: server-rendered "You Might Also Like" slider.
   Same slider behaviour as Minimog's <product-recommendations>, minus the
   /recommendations/products fetch, so the row is always present. */
if (!customElements.get("fm-related-products")) {
  class FmRelatedProducts extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        gridContainer: ".m-product-list",
        slideControls: ".m-slider-controls",
      };
      this.enableSlider = this.dataset.enableSlider === "true";
      this.useScrollMobile = this.dataset.useScrollMobile === "true";
      this.itemsPerPage = parseInt(this.dataset.itemsPerPage, 10) || 4;
      this.paginationType = this.dataset.paginationType || "bullets";
    }

    connectedCallback() {
      this.totalProducts = this.querySelectorAll(".m-product-card").length;
      if (!this.totalProducts) return;
      const ready = () => window.MinimogLibs && window.MinimogLibs.Swiper && window.MinimogTheme && window.MinimogTheme.config;
      const init = () => {
        this.initByScreenSize();
        document.addEventListener("matchMobile", () => this.initByScreenSize());
        document.addEventListener("unmatchMobile", () => this.initByScreenSize());
        if (window.MinimogTheme) {
          MinimogTheme.CompareProduct && MinimogTheme.CompareProduct.setCompareButtonsState && MinimogTheme.CompareProduct.setCompareButtonsState();
          MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState && MinimogTheme.Wishlist.setWishlistButtonsState();
        }
      };
      if (ready()) init();
      else window.addEventListener("load", init, { once: true });
    }

    initByScreenSize() {
      const gridContainer = this.querySelector(this.selectors.gridContainer);
      const slideControls = this.querySelector(this.selectors.slideControls);
      if (!gridContainer) return;

      if (MinimogTheme.config.mqlMobile) {
        this.initSlider();
        if (!this.useScrollMobile) return;
        gridContainer.classList.remove("swiper-container");
        slideControls && slideControls.classList.add("m:hidden");
        this.destroySlider();
        gridContainer.parentNode.classList.add("m-mixed-layout--mobile-scroll");
      } else {
        gridContainer.classList.add("swiper-container");
        gridContainer.parentNode.classList.remove("m-mixed-layout--mobile-scroll");
        slideControls && slideControls.classList.remove("m:hidden");
        this.initSlider();
      }
    }

    destroySlider() {
      if (this.slider) {
        this.slider.destroy(false, true);
        this.slider = null;
      }
    }

    initSlider() {
      const gridContainer = this.querySelector(this.selectors.gridContainer);
      const slideControls = this.querySelector(this.selectors.slideControls);
      if (!gridContainer) return;
      this.destroySlider();

      if (this.enableSlider && this.totalProducts > this.itemsPerPage) {
        const el = this;
        this.slider = new MinimogLibs.Swiper(gridContainer, {
          slidesPerView: this.itemsPerPage >= 2 ? 2 : 1,
          loop: true,
          autoplay: false,
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
            type: this.paginationType,
          },
          threshold: 2,
          breakpoints: {
            1280: { slidesPerView: this.itemsPerPage },
          },
          on: {
            init: function () {
              setTimeout(() => {
                const firstItem = el.querySelector(".m-image") || el.querySelector(".m-placeholder-svg");
                const prevButton = slideControls && slideControls.querySelector(".m-slider-controls__button-prev");
                const nextButton = slideControls && slideControls.querySelector(".m-slider-controls__button-next");
                if (firstItem && slideControls) {
                  slideControls.style.setProperty("--offset-top", parseInt(firstItem.clientHeight, 10) / 2 + "px");
                  prevButton && prevButton.classList.remove("m:hidden");
                  nextButton && nextButton.classList.remove("m:hidden");
                }
              }, 200);
            },
          },
        });

        if (this.slider && !this.controlsBound) {
          this.controlsBound = true;
          const prevBtn = this.querySelector(".m-slider-controls__button-prev");
          const nextBtn = this.querySelector(".m-slider-controls__button-next");
          prevBtn && prevBtn.addEventListener("click", () => this.slider && this.slider.slidePrev());
          nextBtn && nextBtn.addEventListener("click", () => this.slider && this.slider.slideNext());
        }
        slideControls && slideControls.classList.remove("m:hidden");
      } else {
        const innerContainer = gridContainer.querySelector(".m-mixed-layout__inner");
        innerContainer && innerContainer.classList.remove("swiper-wrapper");
        slideControls && slideControls.classList.add("m:hidden");
        gridContainer.classList.remove("swiper-container");
      }
    }
  }
  customElements.define("fm-related-products", FmRelatedProducts);
}
